<app-page-header
  title="Sesión de comisión"
  icon="fa-solid fa-users"
  optionsLabel="Opciones"
  [hasOptions]="!session()"
  [showBack]="!!session()"
  (back)="backToList()">
  <div headerOptions>
    <a class="dropdown-item" (click)="openNew()">
      <i class="fas fa-plus fa-fw me-2 text-primary"></i> Nueva sesión
    </a>
  </div>
</app-page-header>

<div class="container-fluid py-3">
  @if (error()) {
    <div class="alert alert-warning">{{ error() }}</div>
  }

  @if (!session()) {
    <div class="panel p-3 mb-3 border-0 shadow-sm">
      <div class="row align-items-end g-3">
        <div class="col-md-3">
          <label class="form-label fw-bold small text-uppercase text-muted">Desde</label>
          <ng-select [items]="periodsApi.billingPeriods()" bindLabel="displayName" bindValue="id"
            [ngModel]="selectedPeriodStartId()" (ngModelChange)="onStartPeriod($event)"
            [clearable]="false" placeholder="Desde">
          </ng-select>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-bold small text-uppercase text-muted">Hasta</label>
          <ng-select [items]="filteredEndPeriods()" bindLabel="displayName" bindValue="id"
            [ngModel]="selectedPeriodEndId()" (ngModelChange)="selectedPeriodEndId.set($event)"
            [clearable]="false" placeholder="Hasta">
          </ng-select>
        </div>
        <div class="col-md-6 d-flex justify-content-end">
          <button class="btn btn-primary btn-sm" type="button" (click)="openNew()">
            <i class="fas fa-plus me-1"></i> Nueva sesión
          </button>
        </div>
      </div>
    </div>

    <div class="panel p-3 border-0 shadow-sm">
      <div class="table-responsive">
        <table class="table table-sm table-hover align-middle mb-0">
          <thead>
            <tr>
              <th>Periodo</th>
              <th>Estado del periodo</th>
              <th>Lugar</th>
              <th>Votación</th>
              <th>Sesión</th>
              <th>BPM</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (row of visibleSessions(); track row.uuid) {
              <tr role="button" (click)="openRow(row.uuid)">
                <td>{{ periodLabel(row) }}</td>
                <td>{{ periodState(row) }}</td>
                <td>{{ row.placeName || '—' }}</td>
                <td>{{ row.voteMode }}</td>
                <td>{{ row.status }}</td>
                <td>{{ row.linkBpm ? 'Enlazada' : 'Independiente' }}</td>
                <td class="text-end"><i class="fas fa-chevron-right text-muted"></i></td>
              </tr>
            } @empty {
              <tr>
                <td colspan="7" class="text-muted">No hay sesiones en ese rango de periodos.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  } @else {
    @if (session(); as room) {
      <div class="d-flex flex-wrap gap-2 mb-3">
        <span class="badge text-bg-secondary">{{ room.status }}</span>
        <span class="badge text-bg-light border">{{ room.voteMode }}</span>
        <span class="badge text-bg-light border">Presentes {{ room.presentCount }} / quórum {{ room.quorumMin }}</span>
        @if (room.linkBpm) { <span class="badge text-bg-primary">Enlazada al BPM</span> }
        <button class="btn btn-outline-secondary btn-sm ms-auto" type="button" (click)="agenda()">Agenda PDF</button>
        @if (room.status === 'CERRADA') {
          <button class="btn btn-outline-secondary btn-sm" type="button" (click)="acta()">Acta PDF</button>
        }
      </div>

      <div class="row g-3">
        @if (room.isConductor) {
          <div class="col-lg-4">
            <div class="card mb-3">
              <div class="card-body text-center">
                @if (qr()) { <img [src]="qr()" alt="QR para entrar a la sesión" width="180" height="180"> }
                <p class="small text-muted mb-0">Quien escanea entra con su usuario y queda presente.</p>
              </div>
            </div>
            <div class="card mb-3">
              <div class="card-body">
                <h2 class="h6">Agenda</h2>
                @for (item of room.items; track item.id) {
                  <button class="btn btn-sm w-100 text-start mb-1"
                    [class.btn-primary]="item.id === room.currentItemId"
                    [class.btn-outline-secondary]="item.id !== room.currentItemId"
                    type="button" [disabled]="busy() || !room.hasQuorum || room.status !== 'ABIERTA'"
                    (click)="present(item.id)">
                    {{ item.sortOrder }}. {{ item.title }}
                    <span class="float-end">{{ item.phase }}</span>
                  </button>
                }
                @if (!room.hasQuorum) {
                  <p class="small text-warning mb-0">Sin quórum no se presenta ni se vota. La asistencia sí se puede tomar.</p>
                }
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <h2 class="h6">Sin marcar</h2>
                @for (person of absentRoster(); track person.userId) {
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span>{{ person.fullName }}</span>
                    <button class="btn btn-outline-primary btn-sm" type="button" [disabled]="busy()" (click)="mark(person.userId)">Presente</button>
                  </div>
                } @empty { <p class="small text-muted mb-0">Toda la nómina está presente.</p> }
              </div>
            </div>
          </div>
        }

        <div [class]="room.isConductor ? 'col-lg-8' : 'col-12'">
          @if (current(); as item) {
            <div class="card">
              <div class="card-body">
                <h2 class="h5">{{ item.title }}</h2>
                @if (item.summary?.isClaim && !item.grouped) {
                  <p>{{ item.summary?.description || item.summary?.lines?.[0]?.description }}</p>
                  <p class="mb-1">Presupuesto {{ money(item.summary?.lines?.[0]?.budget) }}</p>
                  @if (room.isConductor && room.status === 'ABIERTA' && item.phase !== 'APROBADO' && item.phase !== 'RECHAZADO') {
                    <div class="row g-2 mb-3">
                      <div class="col-md-4">
                        <label class="form-label">Deducible %</label>
                        <input class="form-control" type="number" [ngModel]="deductible()" (ngModelChange)="deductible.set($event)">
                      </div>
                      <div class="col-md-4">
                        <label class="form-label">Monto a reembolsar</label>
                        <input class="form-control" type="number" [ngModel]="amount()" (ngModelChange)="amount.set($event)" readonly>
                      </div>
                      <div class="col-md-4 d-flex align-items-end">
                        <button class="btn btn-outline-primary" type="button" [disabled]="busy()" (click)="saveAmounts()">Guardar deducible</button>
                      </div>
                    </div>
                  } @else {
                    <p>Deducible {{ item.approvedDeductible }}% · Reembolso {{ money(item.approvedAmount) }}</p>
                  }
                }
                @if (item.grouped) {
                  <div class="table-responsive">
                    <table class="table table-sm">
                      <thead>
                        <tr><th>N°</th><th>Campo</th><th>Socio</th><th>Patente</th><th>Modelo</th><th>Marca</th><th>Año</th><th>Valor</th></tr>
                      </thead>
                      <tbody>
                        @for (line of item.summary?.lines || []; track $index) {
                          <tr>
                            <td>{{ $index + 1 }}</td><td>{{ line.campo }}</td><td>{{ line.socio }}</td><td>{{ line.plate }}</td>
                            <td>{{ line.model }}</td><td>{{ line.brand }}</td><td>{{ line.year }}</td><td>{{ money(line.valor) }}</td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                } @else if (docs().length && item.phase !== 'EN_VOTACION') {
                  <app-viewer [items]="docs()" [activeId]="activeDoc()" (onSelect)="activeDoc.set($event)"></app-viewer>
                }

                @if (item.phase === 'EN_VOTACION' && room.voteMode !== 'MANUAL' && canVote()) {
                  <div class="d-flex gap-2 my-3">
                    <button class="btn btn-success" type="button" [disabled]="busy() || !!item.myVote" (click)="cast('APROBAR')">Aprobar</button>
                    <button class="btn btn-outline-secondary" type="button" [disabled]="busy() || !!item.myVote" (click)="cast('NO')">No</button>
                    @if (item.myVote) { <span class="align-self-center text-muted">Su voto quedó registrado.</span> }
                  </div>
                }

                @if (room.isConductor && room.voteMode === 'MIXTA' && item.phase === 'EN_VOTACION') {
                  <div class="border rounded p-3 my-3">
                    <h3 class="h6">Voto en papel</h3>
                    <p class="small text-muted">Faltan: {{ missingNames(item) }}</p>
                    <div class="row g-2">
                      <div class="col-md-6">
                        <select class="form-select" [ngModel]="paperUserId()" (ngModelChange)="paperUserId.set($event)">
                          <option [ngValue]="null">Persona</option>
                          @for (person of item.pendingNames || []; track person.userId) {
                            <option [ngValue]="person.userId">{{ person.fullName }}</option>
                          }
                        </select>
                      </div>
                      <div class="col-md-3">
                        <select class="form-select" [ngModel]="paperDecision()" (ngModelChange)="paperDecision.set($event)">
                          <option value="APROBAR">Aprobar</option>
                          <option value="NO">No</option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <button class="btn btn-primary w-100" type="button" [disabled]="busy()" (click)="savePaper()">Anotar</button>
                      </div>
                    </div>
                  </div>
                }

                @if (room.isConductor && room.status === 'ABIERTA') {
                  <div class="d-flex flex-wrap gap-2 mt-3">
                    @if (item.phase === 'PENDIENTE') {
                      <button class="btn btn-outline-secondary" type="button" [disabled]="busy()" (click)="closePoint({ outcome: 'NO_APROBADO' })">Dejar para otra sesión</button>
                      <button class="btn btn-outline-danger" type="button" [disabled]="busy()" (click)="closePoint({ outcome: 'RECHAZADO' })">Rechazar</button>
                    }
                    @if (item.phase === 'EN_PRESENTACION') {
                      <button class="btn btn-primary" type="button" [disabled]="busy() || !room.hasQuorum" (click)="openVote()">Abrir votación</button>
                      <button class="btn btn-outline-secondary" type="button" [disabled]="busy()" (click)="closePoint({ outcome: 'NO_APROBADO' })">Dejar para otra sesión</button>
                      <button class="btn btn-outline-danger" type="button" [disabled]="busy()" (click)="closePoint({ outcome: 'RECHAZADO' })">Rechazar</button>
                    }
                    @if (item.phase === 'EN_VOTACION' && room.voteMode === 'MANUAL') {
                      <button class="btn btn-success" type="button" [disabled]="busy()" (click)="closePoint({ outcome: 'APROBADO' })">Aprobado</button>
                      <button class="btn btn-outline-secondary" type="button" [disabled]="busy()" (click)="closePoint({ outcome: 'NO_APROBADO' })">No aprobado</button>
                      <button class="btn btn-outline-danger" type="button" [disabled]="busy()" (click)="closePoint({ outcome: 'RECHAZADO' })">Rechazar</button>
                    }
                    @if (item.phase === 'EN_VOTACION' && room.voteMode !== 'MANUAL') {
                      <button class="btn btn-primary" type="button" [disabled]="busy()" (click)="closePoint({})">Cerrar votación</button>
                    }
                    @if (item.phase === 'APROBADO' || item.phase === 'NO_APROBADO' || item.phase === 'RECHAZADO' || item.phase === 'EN_VOTACION') {
                      <button class="btn btn-outline-secondary" type="button" [disabled]="busy()" (click)="closePoint({ action: 'REVOTE' })">Volver a votar</button>
                      <button class="btn btn-outline-secondary" type="button" [disabled]="busy()" (click)="closePoint({ outcome: 'NO_APROBADO' })">Dejar para otra sesión</button>
                      <button class="btn btn-outline-danger" type="button" [disabled]="busy()" (click)="closePoint({ outcome: 'RECHAZADO' })">Rechazar</button>
                    }
                    <button class="btn btn-dark ms-auto" type="button" [disabled]="busy()" (click)="closeSession()">Cerrar sesión</button>
                  </div>
                }

                @if (item.phase === 'APROBADO' || item.phase === 'NO_APROBADO' || item.phase === 'RECHAZADO') {
                  <p class="mt-3 mb-0 fw-semibold">Resultado: {{ item.phase === 'APROBADO' ? 'Aprobado' : item.phase === 'RECHAZADO' ? 'Rechazado' : 'No aprobado' }}
                    @if (item.agreementCode) { · {{ item.agreementCode }} }
                  </p>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  }
</div>

<ng-template #newSessionModal>
  <div class="modal-header">
    <h4 class="modal-title">Nueva sesión</h4>
  </div>
  <div class="modal-body">
    <div class="row mb-3">
      <label class="col-md-4 col-form-label">Periodo</label>
      <div class="col-md-8">
        <ng-select [items]="creatablePeriods()" bindLabel="label" bindValue="id"
          [ngModel]="periodId()" (ngModelChange)="periodId.set($event)"
          [clearable]="false" placeholder="Periodo abierto o cerrado">
        </ng-select>
        <div class="form-text">Se crea sobre el periodo abierto o sobre uno ya cerrado. Un periodo que todavía no se abre no se puede usar.</div>
      </div>
    </div>
    <div class="row mb-3">
      <label class="col-md-4 col-form-label">Lugar</label>
      <div class="col-md-8">
        <input class="form-control" [ngModel]="placeName()" (ngModelChange)="placeName.set($event)">
      </div>
    </div>
    <div class="row mb-3">
      <label class="col-md-4 col-form-label">Votación</label>
      <div class="col-md-8">
        <select class="form-select" [ngModel]="voteMode()" (ngModelChange)="voteMode.set($event)">
          <option value="DIGITAL">Digital</option>
          <option value="MANUAL">Manual</option>
          <option value="MIXTA">Mixta</option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <label class="col-md-4 col-form-label">BPM</label>
      <div class="col-md-8 d-flex align-items-center">
        <div class="form-check mb-0">
          <input class="form-check-input" type="checkbox" id="linkBpm" [ngModel]="linkBpm()" (ngModelChange)="linkBpm.set($event)">
          <label class="form-check-label" for="linkBpm">Enlazar con el BPM</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeNew()">Cancelar</button>
    <button type="button" class="btn btn-primary" [disabled]="busy() || !periodId()" (click)="create()">Crear sesión</button>
  </div>
</ng-template>
